export const SE_HOUSEHOLD_SETUP_NAV_TREE = {
  label: 'SeHouseholdSetup', secondaryItems: [
    {
      label: 'SeHouseholdSetup',
      key: 'se-household-setup',
      attributes: { href: '/docs/se-household-setup/overview' }
    },
    {
      label: 'Whos Participating',
      key: 'whos-participating',
      attributes: { href: '/docs/se-household-setup/whos-participating' }
    },
    {
      label: 'Child Info',
      key: 'child-info',
      attributes: { href: '/docs/se-household-setup/child-info' }
    },
    {
      label: 'Child Contact Info',
      key: 'child-contact-info',
      attributes: { href: '/docs/se-household-setup/child-contact-info' }
    },
    {
      label: 'Parent/Guardian Info',
      key: 'parent-guardian-info',
      attributes: { href: '/docs/se-household-setup/parent-guardian-info' }
    },
    {
      label: 'Invite a Guardian',
      key: 'invite',
      attributes: { href: '/docs/se-household-setup/guardian-invite' }
    },
    {
      label: 'Self Info',
      key: 'self-info',
      attributes: { href: '/docs/se-household-setup/self-info' }
    },
    {
      label: 'Review',
      key: 'review',
      attributes: { href: '/docs/se-household-setup/review' }
    },
    {
      label: 'Unsubscribe Success',
      key: 'unsubscribe-success',
      attributes: { href: '/docs/se-household-setup/unsubscribe-success'}
    }
  ]
}
